import React from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import SelectChemicalProduct from 'components/select-chemical-product';

const SelectChemicalProductWrapper = (props) => (
  <CWOConfigProvider>
    <SelectChemicalProduct {...props} />
  </CWOConfigProvider>
);

export default SelectChemicalProductWrapper;
